// @flow
import { get } from "lodash/fp";
import type { OperationComponent } from "@apollo/client";
import { type TabKey } from "@tvg/atomic-ui/_templates/PoolsNInfo";
import type { RaceProgram } from "@tvg/types/Race";

type Props = {
  currentRace: RaceProgram,
  tabSelected: TabKey,
  trackAbbr: string,
  wagerProfile: string,
  raceNumber: number,
  isOpen: boolean,
  infochanges: boolean
};

const QUERY_VARIABLES = {
  trackAbbr: null,
  wagerProfile: "PORT-Generic"
};

const getProps = (result) => get("data.race", result) || {};

export default {
  skip: (props: Props) => !get("isOpen", props),
  options: (props: Props) => {
    const variables = {
      ...QUERY_VARIABLES,
      trackAbbr: (get("trackAbbr", props) || "").toUpperCase(),
      wagerProfile: get("wagerProfile", props) || "PORT-Generic",
      raceNumber: get("raceNumber", props) || "",
      infochanges: get("tabSelected", props) === "infochanges"
    };

    const poll = get("hasWebSockets", props) ? {} : { pollInterval: 15000 };

    return {
      pollInterval: 0,
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
      ssr: false,
      variables
    };
  },
  props: (result: OperationComponent<Response>) => ({
    ...getProps(result),
    racesChanges: get("data.races", result) || [],
    isLoading:
      result.data.networkStatus === 1 || result.data.networkStatus === 2,
    subscribeToMore:
      get("ownProps.hasWebSockets", result) && !result.data.loading
        ? result.data.subscribeToMore
        : null
  })
};
